(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('UserReviewModalCtrl', userReviewModalCtrl);

    const shopifyReviewUrl = 'https://apps.shopify.com/customily-product-personalizer/reviews?auth=1#reviews';
    const sheduleUrl = 'https://cal.mixmax.com/hellocustomily/30_feedback';

    const messageTypes = {
        1: 'Congratulations, you’ve reached {value} sales!!',
        2: 'Look at you go, you already created {value} templates!!',
        3: 'Congrats, you’ve just published your {value} product!!'
    };

    function ordinal(n) {
        const s = ['th', 'st', 'nd', 'rd'];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    // openInNewTab is used to open a link avoiding adblockers opening in new window
    function openInNewTab(href) {
        Object.assign(document.createElement('a'), {
            target: '_blank',
            href: href
        }).click();
    }

    function userReviewModalCtrl($scope, UsersAPIService, $mdDialog, msgType, msgVal) {
        UsersAPIService.userReviewShowed();

        $scope.closeDialog = function () {
            $mdDialog.hide();
        };

        if (msgType == 3) {
            msgVal = ordinal(msgVal);
        }

        const message = messageTypes[msgType].replace('{value}', msgVal);
        $scope.message = message;
        $scope.step = 'congrats';

        $scope.stepCongratsYes = function () {
            $scope.step = 'rating';
        };

        $scope.stepCongratsNo = function () {
            $scope.step = 'feedback';
        };

        $scope.stepRatingYes = function () {
            openInNewTab(shopifyReviewUrl);
            $mdDialog.hide();
        };

        $scope.stepRatingNo = function () {
            $scope.step = 'feedback';
        };

        $scope.stepFeedbackSend = function () {
            UsersAPIService.userReviewFeedback($scope.feedback);
            $scope.step = 'thanks';
        };

        $scope.stepFeedbackNotNow = function () {
            $mdDialog.hide();
        };

        $scope.stepThanksClose = function () {
            $mdDialog.hide();
        };

        $scope.stepThanksCall = function () {
            openInNewTab(sheduleUrl);
            $mdDialog.hide();
        };
    }
})();
